import { PageLocatorMap } from '../types/PageLocatorMap';

export const loanDocumentMileagePage = {
  alert: {
    error: 'loan-document-mileage-page.form.alert.error',
  },
  footer: {
    root: 'loan-document-mileage-page.footer.root',
  },
  form: {
    h1: 'loan-document-mileage-page.form.h1',
    h2: 'loan-document-mileage-page.form.h2',
    mileageInput: 'loan-document-mileage-page.form.mileage-input',
    mileageInputError: 'loan-document-mileage-page.form.mileage-input-error',
    root: 'loan-document-mileage-page.form.root',
    submitButton: 'loan-document-mileage-page.form.submit-button',
  },
  header: {
    drawerButton: 'loan-document-mileage-page.header.drawer-button',
    previousStepButton:
      'loan-document-mileage-page.header.previous-step-button',
    root: 'loan-document-mileage-page.header.root',
  },
  progress: {
    root: 'loan-document-mileage-page.progress.root',
  },
} as const satisfies PageLocatorMap;
